import { Component, OnDestroy } from '@angular/core';
import { select, Store } from '@ngrx/store';
import {
  getHasProperties,
  getSelectedPropertyId, getPropertyTypes, getPropertySearchResult, getPropertyFilterSettings
} from '../../../property/property-store/property.selectors';
import { AppState } from '../../../../app.reducers';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { PropertyType } from '../../../property/shared/models';
import { PropertySearchFilter, PropertySearchRequest, PropertySearchResult } from '../../models';
import { PropertyFilterSettings } from '../../../shared/models/filter-settings';
import {
  ClearPropertiesAction,
  DeletePropertyAction,
  LoadPropertiesAction
} from '../../../property/property-store/property.actions';
import { Page } from '../../../shared/models/paging';
import { ClearNotificationsAction } from '../../../../shared/redux/global/global.actions';
import { UserProfile } from '../../models';
import { getUserProfile } from '../../redux/user.selectors';

@Component({
  templateUrl: './user-properties.html',
  styleUrls: ['./user-properties.scss'],
  standalone: false
})
export class UserPropertiesComponent implements OnDestroy {

  propertySearchResult$: Observable<PropertySearchResult>;
  propertyFilterSettings$: Observable<PropertyFilterSettings>;
  propertyTypes$: Observable<PropertyType[]>;
  hasProperties$: Observable<boolean>;
  selectedPropertyId$: Observable<string>;
  isLogin = false;
  filter: PropertySearchFilter;
  userProfile$: Observable<UserProfile>;

  constructor(private store: Store<AppState>,
    private router: Router) {
    this.propertySearchResult$ = this.store.pipe(select(getPropertySearchResult));
    this.propertyFilterSettings$ = this.store.pipe(select(getPropertyFilterSettings));
    this.propertyTypes$ = this.store.pipe(select(getPropertyTypes));
    this.hasProperties$ = this.store.pipe(select(getHasProperties));
    this.selectedPropertyId$ = this.store.pipe(select(getSelectedPropertyId));
    this.userProfile$ = this.store.pipe(select(getUserProfile));

    const navigation = this.router.getCurrentNavigation();
    if (navigation && navigation.extras && navigation.extras.state) {
      this.isLogin = navigation.extras.state.isLogin;
    }
  }

  ngOnDestroy() {
    this.store.dispatch(new ClearPropertiesAction());
  }

  onArchive(propertyId: string) {

    this.store.dispatch(new ClearNotificationsAction());
    this.store.dispatch(new DeletePropertyAction(propertyId));
  }

  onFilterChanged(filter: PropertySearchFilter) {
    this.filter = filter;
    const request = new PropertySearchRequest(filter);
    this.store.dispatch(new LoadPropertiesAction(request));
  }

  onPageChanged(pageNumber: number) {
    const page = new Page();
    page.pageNumber = pageNumber;
    const request = new PropertySearchRequest(this.filter, page);
    this.store.dispatch(new LoadPropertiesAction(request));
  }
}
